var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerStatuses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4 0h7.6l-7.6 13.044586h7.3v-.3057325h.3l-.3.3057325-14.4 18.955414 5.5-15.388535h-6.8z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerStatuses);
export default __webpack_public_path__ + "static/media/Charger Statuses.0d383ddfec1e3aeeec3a505abc3bfb3b.svg";
export { ForwardRef as ReactComponent };